export enum PasswordValidationErrors {
  NumberOrSymbol = 'NumberOrSymbol',
  Lowercase = 'Lowercase',
  Uppercase = 'Uppercase',
  Characters = 'Characters',
}
